import { render, staticRenderFns } from "./rules_user_protocal.vue?vue&type=template&id=29b4562c&scoped=true&"
import script from "./rules_user_protocal.vue?vue&type=script&lang=js&"
export * from "./rules_user_protocal.vue?vue&type=script&lang=js&"
import style0 from "./rules_user_protocal.vue?vue&type=style&index=0&id=29b4562c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b4562c",
  null
  
)

export default component.exports